"use client";

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import { createContext, useContext, useMemo } from "react";
interface CreateDropEmojiPickerLayer {
  readonly desktopZIndex: number;
  readonly mobileZIndexClassName: string;
}
const DEFAULT_CREATE_DROP_EMOJI_PICKER_LAYER: CreateDropEmojiPickerLayer = {
  desktopZIndex: 1000,
  mobileZIndexClassName: "tw-z-[1010]"
};
const CreateDropEmojiPickerLayerContext = createContext<CreateDropEmojiPickerLayer>(DEFAULT_CREATE_DROP_EMOJI_PICKER_LAYER);
export function CreateDropEmojiPickerLayerProvider(t0) {
  const $ = _c(6);
  const {
    children,
    desktopZIndex: t1,
    mobileZIndexClassName: t2
  } = t0;
  const desktopZIndex = t1 === undefined ? DEFAULT_CREATE_DROP_EMOJI_PICKER_LAYER.desktopZIndex : t1;
  const mobileZIndexClassName = t2 === undefined ? DEFAULT_CREATE_DROP_EMOJI_PICKER_LAYER.mobileZIndexClassName : t2;
  let t3;
  if ($[0] !== desktopZIndex || $[1] !== mobileZIndexClassName) {
    t3 = {
      desktopZIndex,
      mobileZIndexClassName
    };
    $[0] = desktopZIndex;
    $[1] = mobileZIndexClassName;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const value = t3;
  let t4;
  if ($[3] !== children || $[4] !== value) {
    t4 = <CreateDropEmojiPickerLayerContext.Provider value={value}>{children}</CreateDropEmojiPickerLayerContext.Provider>;
    $[3] = children;
    $[4] = value;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}
export function useCreateDropEmojiPickerLayer() {
  return useContext(CreateDropEmojiPickerLayerContext);
}